import { VStack, Box } from '@chakra-ui/react';
import type { RefObject } from 'react';

export interface CallMinWindowPanelProps {
  mediaType?: number;
  bg: string;
  avatar?: string;
  avatarSize?: number;
  children: React.ReactNode;
  pindSidePanelChildren: React.ReactNode;
  footerChildren: React.ReactNode;
  isConnect?: boolean;
  hoverLeaveRef: RefObject<HTMLDivElement | null>;
}
export function CallMinWindowPanel({
  bg,
  avatar,
  avatarSize = 800,
  children,
  pindSidePanelChildren,
  footerChildren,
  isConnect,
  hoverLeaveRef,
}: CallMinWindowPanelProps) {
  return (
    <VStack
      ref={hoverLeaveRef}
      alignItems="center"
      rounded="xl"
      color="white"
      w="full"
      overflow="hidden"
      h="full"
      boxShadow="0 4px 4px 0 rgba(0, 0, 0, 0.10)"
      pos="relative"
    >
      <VStack
        alignItems="center"
        w="full"
        h="full"
        justifyContent="space-between"
        gap="0"
        // When avatar exists, use solid dark background under the blurred image
        // to avoid showing the page's light background through transparency.
        bg={avatar ? 'lightgray' : `linear-gradient(rgba(0,0,0,0.7)), ${bg}`}
        pos="relative"
        _before={
          avatar
            ? {
                content: '""',
                position: 'absolute',
                inset: 0,
                bgImage: `url(${avatar})`,
                bgSize: `${avatarSize}px ${avatarSize}px`,
                bgPos: 'center',
                bgRepeat: 'no-repeat',
                filter: `blur(${avatarSize / 10}px)`,
                zIndex: -1,
              }
            : undefined
        }
        zIndex={1}
      >
        <Box
          w="full"
          pt={isConnect ? '0' : '12'}
          px={isConnect ? '0' : '4'}
          pb={isConnect ? '0' : '9'}
          pos="relative"
          h={isConnect ? 'calc(100% - 82px)' : 'full'}
        >
          {children}
        </Box>

        {pindSidePanelChildren && (
          <Box pos="absolute" bottom={90} right="2.5" width="126px" height="72px">
            {pindSidePanelChildren}
          </Box>
        )}

        {footerChildren}
      </VStack>
    </VStack>
  );
}
